import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styles from './DonationButton.styles';

import { YELLOW_CBX } from '../../../constants/colors';

const Button = styled.button`
  margin-top:1em;
  ${Styles.button};
  ${Styles.text};
`;

/**
 * DonationButton component
 * @property {Object} props - component props
 * @returns {JSX}
 */
const DonationButton = ({
  amount, selected, ...props
}) => {
  return (
    <Button
      value={amount}
      selected={selected}
      mycustomattribute={selected}
      {...props}
    >
        ${amount}
    </Button>
  );
};

DonationButton.propTypes = {
  amount: PropTypes.number,
  selected: PropTypes.bool,
};

DonationButton.defaultProps = {
  amount: 1,
  selected: false,
};

export default DonationButton;
